module.exports = __webpack_public_path__ + "static/ExtendIT-Slider4-8ff60d1b50ee1b701ac183209be8b6fb.jpg";